var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deferredExchange-content"},[_c('div',{staticClass:"breadcrumb"},[_c('breadcrumb',{attrs:{"urlName":"Deferred Exchange"},on:{"goBack":_vm.goBack}})],1),_c('div',{staticClass:"deferredExchange"},[_c('img',{attrs:{"src":_vm.isMaxScreen ? _vm.image : _vm.image1,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }